import { Inputs } from '../../../types';
import { TProjectConfigurationParameter } from '../../../../../entries/common/widgets/project-configuration/context';

const SEPARATOR = ',';

export const getDefaultParams = (
  projectConfigurationParameters: Array<TProjectConfigurationParameter> | undefined
): Inputs => {
  const transformToArrayParamNames = ['doorType', 'colour'];
  let params: { [key: string]: string | string[] | null } = {
    doorType: null,
    colour: null,
    forWetRooms: null,
  };
  if (!projectConfigurationParameters) {
    return params as Inputs;
  }

  projectConfigurationParameters.forEach(({ key, value }) => {
    if (Object.keys(params).includes(key)) {
      params[key] = transformToArrayParamNames.includes(key) ? value.split(SEPARATOR) : value;
    }
  });

  return params as Inputs;
};
